import React, { useState } from "react";
import classnames from "classnames";
import Button from "Shared/Button";
import ActionOptions from "./ActionOptions";
import PrintOptions from "./PrintOptions";
import { MasterFor } from "Shared/MasterFor";
import { translate } from "Shared/translate";
import { customProductsPageUrl } from "Shared/known-urls";
import * as base from "./base.scss";
import ValidationFeedback from "./ValidationFeedback";
export var DropDownListType;
(function (DropDownListType) {
    DropDownListType[DropDownListType["Print"] = 0] = "Print";
    DropDownListType[DropDownListType["Actions"] = 1] = "Actions";
    DropDownListType[DropDownListType["MasterFor"] = 2] = "MasterFor";
    DropDownListType[DropDownListType["None"] = 3] = "None";
})(DropDownListType || (DropDownListType = {}));
const Toolbar = (props) => {
    const [ActiveDropDown, SetActiveDropDown] = useState(DropDownListType.None);
    const [ValidationFeedbackIsVisible, SetValidationFeedbackIsVisible] = useState(false);
    const [ValidationFeedbackText, SetValidationFeedbackText] = useState("");
    const handleSelect = (type) => {
        SetValidationFeedbackIsVisible(false);
        SetActiveDropDown(type);
    };
    const showValidationFeedback = (visible) => {
        SetValidationFeedbackIsVisible(visible);
    };
    const setValidationFeedbackMessage = (text) => {
        SetValidationFeedbackText(text);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: base.toolbarWrap },
            React.createElement(ActionOptions, { active: ActiveDropDown == DropDownListType.Actions, handleDropDownSelect: handleSelect, totalAmountOfPantries: props.lists.length, selectedLists: props.lists.filter((x) => x.selected), showValidationFeedback: (visible) => {
                    showValidationFeedback(visible);
                }, setValidationFeedbackMessage: (text) => {
                    setValidationFeedbackMessage(text);
                } }),
            React.createElement(PrintOptions, { active: ActiveDropDown == DropDownListType.Print, handleDropDownSelect: handleSelect }),
            React.createElement(MasterFor, Object.assign({ className: base.toolButton }, props)),
            React.createElement("div", { className: classnames(base.buttonWrapper) },
                React.createElement(Button, { appearance: ["secondary", "toolbar"], href: customProductsPageUrl().url }, translate("/Account/ProductList/ManageArticles")))),
        React.createElement(ValidationFeedback, { visible: ValidationFeedbackIsVisible, text: ValidationFeedbackText })));
};
export default Toolbar;
